import React, { Suspense, lazy } from 'react'
import { Redirect, Switch } from 'react-router-dom'
import { FallbackView } from '../../_metronic/partials'
import ActivatedPageRoute from './ActivatedPageRoute'
import { PAGE_PERMISSION } from '../modules/roles/constant/role-default'
import { Page } from '../modules/roles/models/role-model'
import ActivePageBasedRedirect from './ActivePageBasedRedirect'
import DashboardPage from '../modules/dashboard/DashboardPage'

type Props = {
  activePages: Page[]
}

const PrivateRoutes: React.FC<Props> = ({ activePages = [] }) => {
  const LocationPage = lazy<React.FC>(() => import('../modules/locations/LocationPage'))
  const FaultedAssetPage = lazy<React.FC>(() => import('../modules/faulted-assets/FaultedAssetPage'))
  const ServiceTicketPage = lazy<React.FC>(() => import('../modules/service-tickets/ServiceTicketPage'))
  const ReportPage = lazy<React.FC>(() => import('../modules/reports/ReportPage'))

  const FeaturePage = lazy<React.FC>(() => import('../modules/features/FeaturePage'))
  const ChartsPage = lazy<React.FC>(() => import('../modules/charts/ChartPage'))
  const UsersPage = lazy<React.FC>(() => import('../modules/users/UserPage'))
  const RolesPage = lazy<React.FC>(() => import('../modules/roles/RolePage'))
  const SettingsPage = lazy<React.FC>(() => import('../modules/settings/SettingsPage'))
  const AuditsPage = lazy<React.FC>(() => import('../modules/audits/AuditPage'))
  const GroupsPage = lazy<React.FC>(() => import('../modules/groups/GroupsPage'))
  const ChargersPage = lazy<React.FC>(() => import('../modules/chargers/ChargersPage'))
  const FoyerViewPage = lazy<React.FC>(() => import('../modules/foyer-view/FoyerViewPage'))

  return (
    <Suspense fallback={<FallbackView />}>
      <Switch>
        {/*<Route path='/user' render={() => <UserPage />} />*/}
        {/*<Route path='/role' render={() => <RolePage />} />*/}
        {/*<Route path='/feature' render={() => <FeaturePage />} />*/}

        <ActivatedPageRoute
          path="/dashboard"
          component={DashboardPage}
          permission={PAGE_PERMISSION.Dashboard}
          activePages={activePages}
        />

        <ActivatedPageRoute
          path="/foyer-view"
          component={FoyerViewPage}
          permission={PAGE_PERMISSION.FoyerView}
          activePages={activePages}
        />

        <ActivatedPageRoute
          path="/chargers"
          component={ChargersPage}
          permission={PAGE_PERMISSION.Chargers}
          activePages={activePages}
        />

        <ActivatedPageRoute
          path="/faulted-assets"
          component={FaultedAssetPage}
          permission={PAGE_PERMISSION.Faulted_Assets}
          activePages={activePages}
        />

        {/* <ActivatedPageRoute
          path="/service-tickets"
          component={ServiceTicketPage}
          permission={PAGE_PERMISSION.Service_Tickets}
          activePages={activePages}
        /> */}

        <ActivatedPageRoute
          path="/reports"
          component={ReportPage}
          permission={PAGE_PERMISSION.Reports}
          activePages={activePages}
        />

        {/* <ActivatedPageRoute
          path="/charts"
          component={ChartsPage}
          permission={PAGE_PERMISSION.Admin_Charts}
          activePages={activePages}
        /> */}

        <ActivatedPageRoute
          path="/user"
          component={UsersPage}
          permission={PAGE_PERMISSION.Admin_Users}
          activePages={activePages}
        />


        <ActivatedPageRoute
          path="/groups"
          component={GroupsPage}
          permission={PAGE_PERMISSION.Admin_Groups}
          activePages={activePages}
        />

        <ActivatedPageRoute
          path="/role"
          component={RolesPage}
          permission={PAGE_PERMISSION.Admin_Roles}
          activePages={activePages}
        />

        <ActivatedPageRoute
          path="/settings"
          component={SettingsPage}
          permission={PAGE_PERMISSION.Admin_Settings}
          activePages={activePages}
        />

        {/* <ActivatedPageRoute
          path="/audit"
          component={AuditsPage}
          permission={PAGE_PERMISSION.Admin_Audit}
          activePages={activePages}
        /> */}

        <ActivePageBasedRedirect></ActivePageBasedRedirect>
        <Redirect to="error/404" />
      </Switch>
    </Suspense>
  )
}

export { PrivateRoutes }
